import React from 'react';
import imghackaton from '../img/logo-hackaton-3d.png';
import imgLogo from '../img/logo-ies.svg';

export default function Header() {     

  return (
    <header className="bmd-layout-header">
        <button className="navbar-toggler btnmenu" type="button" data-toggle="drawer" data-target="#dw-p1">
            <span className="sr-only">Toggle drawer</span>
            <i className="material-icons">menu</i>
        </button>
        <img src={imghackaton} className="img-fluid logoh" alt="hackaton" />
        <a href="https://www.ies21.edu.ar/" target="_blank" rel="noreferrer noopener" className="hlogo mt-4"><img src={imgLogo} className="img-fluid" alt="ies21" /></a>        
    </header>
  );
}